var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverallMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 32,
    viewBox: "0 0 122 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 122,
    height: 19,
    viewBox: "0 0 122 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OVER/LL"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M113.441 0.29834V15.3193H122V18.4279H109.763V0.29834H113.441Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M95.5065 0.29834V15.3193H104.065V18.4279H91.828V0.29834H95.5065Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M84.217 0.671265H85.86L80.8082 18.776H79.1651L84.217 0.671265Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M64.1156 11.2407V18.4279H60.437V0.29834H70.0257C71.5462 0.29834 72.6743 0.696245 73.4835 1.5418C74.3419 2.43708 74.8323 3.75515 74.8323 5.19756C74.8323 7.41091 73.8269 8.87818 71.8159 9.674C74.0966 10.6688 74.1947 10.9175 74.2928 16.2643C74.2928 17.0601 74.5135 17.4332 75.0776 17.7565V18.4279H71.1293C70.6879 17.5575 70.5898 17.0353 70.5898 15.3193C70.5898 15.0457 70.5898 14.5981 70.6143 14.1256V13.3795C70.6143 11.8873 69.9276 11.2407 68.3336 11.2407H64.1156ZM64.1156 8.13211H68.5543C69.6088 8.13211 70.0748 8.00776 70.4917 7.6596C70.9331 7.28656 71.1538 6.59023 71.1538 5.71981C71.1538 4.87426 70.9331 4.25253 70.4917 3.87949C70.0257 3.50646 69.6088 3.40698 68.5543 3.40698H64.1156V8.13211Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.7913 10.619V15.3193H54.478V18.4279H41.1127V0.29834H54.0366V3.40698H44.7913V7.51038H53.35V10.619H44.7913Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.8989 18.4279H26.7844L20.7516 0.29834H24.4547L28.4275 13.9515L32.3267 0.29834H36.0298L29.8989 18.4279Z",
    fill: "#0D0907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.58322 0C11.1827 0 13.1446 0.795812 14.7141 2.51178C16.3081 4.22775 17.2155 6.78927 17.2155 9.62435C17.2155 12.1859 16.2591 14.822 14.7141 16.4882C13.1691 18.1793 11.1582 19 8.60774 19C6.0573 19 4.04638 18.1793 2.5014 16.4882C0.907369 14.7723 0 12.2107 0 9.5C0 6.78927 0.907369 4.25262 2.5014 2.51178C4.02185 0.845551 6.08182 0 8.58322 0ZM8.60774 3.18325C5.61588 3.18325 3.67852 5.67016 3.67852 9.5C3.67852 13.3298 5.61588 15.8168 8.60774 15.8168C11.5506 15.8168 13.537 13.3298 13.537 9.59948C13.537 5.67016 11.6241 3.18325 8.60774 3.18325Z",
    fill: "#0D0907"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.5008 24)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 57,
    height: 8.00257,
    viewBox: "0 0 57 8.00257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "STUDIOS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.7409 2.36725H55.829C55.8187 1.36169 55.1451 0.817017 53.943 0.817017C52.9275 0.817017 52.2539 1.33027 52.2539 2.10539C52.2539 2.69197 52.5855 2.98525 53.4974 3.23664L55.3938 3.7499C56.4197 4.03271 57 4.72403 57 5.66674C57 6.32664 56.6788 7.00749 56.171 7.416C55.6839 7.79308 54.9482 8.00257 54.0467 8.00257C52.8964 8.00257 52.0259 7.63596 51.5078 6.91322C51.2073 6.49424 51.0726 6.03335 51.0622 5.33156H51.9741C51.9638 5.80291 52.0881 6.16952 52.3679 6.50471C52.7306 6.94464 53.2798 7.14366 54.1088 7.14366C54.7202 7.14366 55.1969 7.03891 55.4974 6.81895C55.8187 6.58851 56.0363 6.16952 56.0363 5.76102C56.0363 5.16396 55.6114 4.77641 54.6477 4.52502L52.7721 4.02224C51.7772 3.76037 51.2902 3.1738 51.2902 2.24156C51.2902 0.858915 52.3161 0 53.9741 0C55.2487 0 56.1295 0.460881 56.544 1.34075C56.7099 1.69688 56.7409 1.84353 56.7409 2.36725Z",
    fill: "#AE978E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.5589 0C46.7765 0 48.2169 1.60261 48.2169 4.06413C48.2169 5.31061 47.7299 6.49424 46.9112 7.19603C46.2998 7.71976 45.4915 8.00257 44.5693 8.00257C42.3828 8.00257 40.9216 6.39996 40.9216 4.00129C40.9216 1.61308 42.3931 0 44.5589 0ZM44.5589 0.858915C42.9527 0.858915 41.8853 2.11586 41.8853 4.00129C41.8853 5.88671 42.9527 7.14366 44.5693 7.14366C46.1651 7.14366 47.2532 5.88671 47.2532 4.04319C47.2532 2.10539 46.1962 0.858915 44.5589 0.858915Z",
    fill: "#AE978E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.5816 0.125671V7.76163H36.6075V0.125671H37.5816Z",
    fill: "#AE978E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.9425 7.76163V0.125671H29.8544C31.7715 0.125671 32.9321 1.57116 32.9321 3.93842C32.9321 6.31614 31.7611 7.76163 29.8544 7.76163H26.9425ZM27.9063 6.90272H29.6886C31.1808 6.90272 31.9684 5.88669 31.9684 3.94889C31.9684 2.00062 31.1808 0.984586 29.6886 0.984586H27.9063V6.90272Z",
    fill: "#AE978E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.1895 0.125671H23.1532V5.48865C23.1532 7.01794 22.0133 8.00255 20.2413 8.00255C18.4486 8.00255 17.3502 7.03889 17.3502 5.48865V0.125671H18.3139V5.48865C18.3139 6.06475 18.4901 6.45231 18.8631 6.7456C19.2258 7.00747 19.6818 7.14363 20.2413 7.14363C21.4538 7.14363 22.1895 6.51516 22.1895 5.48865V0.125671Z",
    fill: "#AE978E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.8819 0.984586V7.76163H10.9182V0.984586H8.43115V0.125671H14.3586V0.984586H11.8819Z",
    fill: "#AE978E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.67872 2.36725H4.76681C4.75645 1.36169 4.08287 0.817017 2.88081 0.817017C1.86527 0.817017 1.1917 1.33027 1.1917 2.10539C1.1917 2.69197 1.52331 2.98525 2.43522 3.23664L4.33158 3.7499C5.35748 4.03271 5.93778 4.72403 5.93778 5.66674C5.93778 6.32664 5.61654 7.00749 5.10877 7.416C4.62173 7.79308 3.88598 8.00257 2.98444 8.00257C1.83418 8.00257 0.963724 7.63596 0.445593 6.91322C0.145077 6.49424 0.0103626 6.03335 0 5.33156H0.911911C0.901548 5.80291 1.0259 6.16952 1.30569 6.50471C1.66838 6.94464 2.2176 7.14366 3.04661 7.14366C3.65801 7.14366 4.13469 7.03891 4.4352 6.81895C4.75645 6.58851 4.97406 6.16952 4.97406 5.76102C4.97406 5.16396 4.54919 4.77641 3.58547 4.52502L1.70983 4.02224C0.715021 3.76037 0.227978 3.1738 0.227978 2.24156C0.227978 0.858915 1.25388 0 2.9119 0C4.1865 0 5.06732 0.460881 5.48183 1.34075C5.64763 1.69688 5.67872 1.84353 5.67872 2.36725Z",
    fill: "#AE978E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallMain);
export default __webpack_public_path__ + "static/media/overall-main.8ef0e96e2dbe60f080c478b01e3d7a4a.svg";
export { ForwardRef as ReactComponent };